import React from 'react';
import styled from 'styled-components';
import Step1Image from '../assets/1.png';
import Step2Image from '../assets/2.png';
import Step3Image from '../assets/3.png';
import Step4Image from '../assets/4.png';
import Step5Image from '../assets/5.png';

const DeleteAccountCustomer: React.FC = () => {
  return (
    <Container>
      <ContentWrapper>
        {/* Step 1 */}
        <StepSection>
          <StepTitle>Step 1: Select Reason for Leaving</StepTitle>
          
          <ImageContainer>
            <StepImage src={Step1Image} alt="Select reason for deleting account" />
          </ImageContainer>

          <DescriptionText>
            Choose a reason why you wish to delete your account from the available options.
          </DescriptionText>
        </StepSection>

        {/* Step 2 */}
        <StepSection>
          <StepTitle>Step 2: Confirm Understanding</StepTitle>
          
          <ImageContainer>
            <StepImage src={Step2Image} alt="Confirm account deletion understanding" />
          </ImageContainer>

          <DescriptionText>
            Read and confirm that you understand the consequences of deleting your account by checking the required statements.
          </DescriptionText>
        </StepSection>

        {/* Step 3 */}
        <StepSection>
          <StepTitle>Step 3: Confirm Phone Number</StepTitle>
          
          <ImageContainer>
            <StepImage src={Step3Image} alt="Enter phone number to confirm deletion" />
          </ImageContainer>

          <DescriptionText>
            Enter your phone number to confirm that you want to proceed with the permanent deletion of your account.
          </DescriptionText>
        </StepSection>

        {/* Step 4 */}
        <StepSection>
          <StepTitle>Step 4: Final Confirmation</StepTitle>
          
          <ImageContainer>
            <StepImage src={Step4Image} alt="Final confirmation step" />
          </ImageContainer>

          <DescriptionText>
            Review your decision and proceed with the account deletion.
          </DescriptionText>
        </StepSection>

        {/* Step 5 */}
        <StepSection>
          <StepTitle>Step 5: Account Deleted Successfully</StepTitle>
          
          <ImageContainer>
            <SuccessImage src={Step5Image} alt="Account deleted successfully" />
          </ImageContainer>

          <DescriptionText>
            Your account has been successfully deleted. You can return to the homepage.
          </DescriptionText>
        </StepSection>
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-family: 'Hanken Grotesk', sans-serif;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding: 24px 0;
`;

const StepSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const StepTitle = styled.h2`
  font-size: 22px;
  font-weight: 600;
  color: #1f2933;
  text-align: center;
  margin: 0 0 24px;
`;

const DescriptionText = styled.p`
  font-size: 16px;
  color: #374151;
  text-align: center;
  margin: 24px 0 0;
  line-height: 1.6;
`;

const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 24px 0;
`;

const StepImage = styled.img`
  max-width: 60%;
  max-height: 400px;
  width: auto;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  object-fit: contain;
  
  @media (max-width: 768px) {
    max-width: 70%;
    max-height: 350px;
  }
`;

const SuccessImage = styled.img`
  max-width: 50%;
  max-height: 300px;
  width: auto;
  height: auto;
  border-radius: 8px;
  object-fit: contain;
  
  @media (max-width: 768px) {
    max-width: 60%;
    max-height: 250px;
  }
`;

export default DeleteAccountCustomer;

